/**
 * This file is to map trigger, from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import { TriggerEvents,  stripeTriggerEvents } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import {
	getEdge,
	getValudOfVariable,
} from "../../../../../containers/editor/utils/utils";

const getShadows = (condition) => {
	let shadows = [];
	let varValue;
	if (condition.or) {
		varValue = getValudOfVariable(
			condition.or[condition.or.length - 1].eq?.var
		).replace("input.data.step in ", "");

		if (varValue[0] !== "[") return false;
		shadows = JSON.parse(varValue).filter((v) => !v.includes("_loop"));
	}
	return shadows;
};


/**
 *
 * @param {*} audience
 */
const parseBEStripeChargeSucceededToFE = (
	trigger,
	nextSubAutomation,
	nextStepCondition,
	nextType,
	index
) => {
	let shadows = [];
	if (nextStepCondition) {
		shadows = getShadows(nextStepCondition);
	}
	const id = `event_${+new Date()}${index}`;
	const triggerEvent = {
		id: id,
		type: "editorNode",
		data: {
			baseId: "Stripe.ChargeSucceeded",
			id: id,
			...stripeTriggerEvents()[0],
			initialElement: true,
			shadows: shadows,
		},
	};

	const firstTargetId = nextSubAutomation.id;
	const links = getEdge("branchingEdge", triggerEvent.id, firstTargetId);
	return {
		events: [triggerEvent],
		links: [links],
	};
};
const parseFEStripeChargeSucceededToBE = (FEEvent, events) => {
	return {
            name: "Stripe.ChargeSucceeded"
	};
};
export { parseBEStripeChargeSucceededToFE, parseFEStripeChargeSucceededToBE};